import { FormInput } from '@/modules/kycModule/components';
import { DOCUMENT_NUMBER_REGEX } from '@/utils/static';
import { useTranslation } from 'react-i18next';

export const DocumentNumberInput = ({ form, ...props }) => {
  const { t } = useTranslation();
  const { rules, ...otherForm } = form;
  return (
    <FormInput
      form={{
        ...otherForm,
        rules: {
          pattern: {
            value: DOCUMENT_NUMBER_REGEX,
            message: t(
              'Only uppercase latin characters and numbers (no special characters and spaces allowed)'
            )
          }
        }
      }}
      {...props}
    />
  );
};
